import { Link, Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public')({
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <div className="min-h-screen bg-surface-canvas text-body">
      <header className="sticky top-0 z-10 bg-surface/80 backdrop-blur border-b border-border-soft">
        <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" className="font-semibold text-ink tracking-tight">
            <span
              className="bg-clip-text text-transparent"
              style={{ backgroundImage: 'var(--brand-gradient)' }}
            >
              MEIDEI
            </span>
          </Link>
          <nav className="flex items-center gap-6 text-sm">
            <Link to="/legal/privacy" className="text-quiet hover:text-ink">
              Privacidad
            </Link>
            <Link
              to="/login"
              className="text-white px-3 py-1.5 rounded-md"
              style={{ backgroundImage: 'var(--brand-gradient)' }}
            >
              Iniciar sesión
            </Link>
          </nav>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="border-t border-border-soft mt-16 py-8 text-center text-sm text-quiet">
        © 2026 MEIDEI —{' '}
        <Link to="/legal/terms" className="underline">
          Términos
        </Link>{' '}
        ·{' '}
        <Link to="/legal/privacy" className="underline">
          Privacidad
        </Link>
      </footer>
    </div>
  );
}
